import React, { FC } from 'react';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';
import { TExploreServicesCardProps } from './types/card.types';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { CardModel } from '../../../../models/card.model';
import fields from '../../../../constants/fields.const';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import ExploreServicesCardContent from './exploreServicesCardContent';
import './style.scss';

const ExploreServicesCard: FC<TExploreServicesCardProps> = (props: TExploreServicesCardProps) => {
  const model = new CardModel(props);
  const {sitecoreContext} = useSitecoreContext();
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  return (
    <article className="explore-services-card">
      {sitecoreContext.pageEditing ? (
        <div className="explore-services-card__link">
          <ExploreServicesCardContent
            id={props.id}
            fields={fields}
            icon={model.icon}
            title={model.title}
            subtitle={model.subtitle}
            sitecoreContext={sitecoreContext}
            link={model.link}
          />
        </div>
      ) : (
        <RoutableSitecoreLink field={model.link} target={targetLinkdsk(model?.link, isDesktop)} className="explore-services-card__link">
          <ExploreServicesCardContent
            id={props.id}
            fields={fields}
            icon={model.icon}
            title={model.title}
            subtitle={model.subtitle}
            sitecoreContext={sitecoreContext}
            link={model.link}
          />
        </RoutableSitecoreLink>
      )}
      <hr className={props.last ? 'explore-services-card__line explore-services-card__line--last' : 'explore-services-card__line'} />
    </article>
  );
};

export default ExploreServicesCard;
